import { Component, Input } from '@angular/core';
import { ChantMediaModel } from '@core/models/ce/chant-media-model';
import { MediaPlayerService } from '@core/service/media-player/media-player.service';
import { ImportALlModule } from '@shared/imports';
import { MediaPlayerButtonComponent } from '../media-player-button/media-player-button.component';
import { EnumImages } from '@shared/tools/constants/constants';

@Component({
  selector: 'app-media-solfege-one-button',
  standalone: true,
  imports: [
    ImportALlModule,
  ],
  templateUrl: './media-solfege-one-button.component.html',
  styleUrl: './media-solfege-one-button.component.scss'
})
export class MediaSolfegeOneButtonComponent {

  @Input() row!: any;
  @Input() faIcon: string = '';
  @Input() srcImg: string = EnumImages.IC_SOLFEGE;
  public enumImages = EnumImages;

  constructor(public mediaPlayerService: MediaPlayerService){}

    getDefaultMedia(row: any): ChantMediaModel | undefined {
      return row?.chantMediaAudioMerge?.find((x: any) => x.isDefault === true);
    }
}
